import Show from '@/vues/sources/show.vue';

export default [
  {
    path: '/sources/:id',
    name: 'Source Show',
    component: Show,
    meta: {
      usePathAnalytics: true
    }
  }
];
